(() => {
  const HOST_SELECTOR = '#opus-shadow-container';
  const ITEM_SELECTOR = '.cd-product-item';
  const CONTENT_SELECTOR = '.cd-product-item-content';
  const PREVIEW_CLASS = 'rf-ego-design-preview';
  const STYLE_ID = 'rf-ego-design-preview-style';
  const PROPERTY_NAMES = [
    'Diseño personalizado',
    '_Archivo de producción NANO',
    '_Archivo de producción ARMOUR',
  ];

  let rootObserver = null;
  let observedRoot = null;
  let refreshTimer = null;
  let refreshRunning = false;
  let refreshAgain = false;

  function normalizeFileUrl(value) {
    if (typeof value !== 'string') return '';
    const trimmed = value.trim();
    if (!trimmed) return '';
    if (trimmed.startsWith('//')) return `${window.location.protocol}${trimmed}`;
    if (trimmed.startsWith('/')) return `${window.location.origin}${trimmed}`;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return '';
  }

  function designUrl(item) {
    const properties = item && item.properties;
    if (!properties) return '';
    for (const name of PROPERTY_NAMES) {
      const url = normalizeFileUrl(properties[name]);
      if (url) return url;
    }
    return '';
  }

  function variantIdFromCard(card) {
    const content = card.querySelector(CONTENT_SELECTOR);
    if (!content) return '';
    const token = Array.from(content.classList).find((name) => /^id\d+$/.test(name));
    return token ? token.slice(2) : '';
  }

  async function getCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('No se ha podido leer el carrito.');
    return response.json();
  }

  function ensureStyles(root) {
    if (root.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .${PREVIEW_CLASS}{display:grid;grid-template-columns:64px minmax(0,1fr);gap:10px;align-items:center;margin-top:9px;padding:8px;border:1px solid #d9eee3;border-radius:8px;background:#f4fbf7}
      .${PREVIEW_CLASS}__image{display:block;width:64px!important;height:46px!important;object-fit:contain!important;border-radius:5px;background:#fff;border:1px solid #e5e7eb}
      .${PREVIEW_CLASS}__copy{display:flex;min-width:0;flex-direction:column;gap:3px;text-align:left}
      .${PREVIEW_CLASS}__label{font-size:11px!important;line-height:14px!important;font-weight:700!important;color:#111!important}
      .${PREVIEW_CLASS}__link{font-size:12px!important;line-height:15px!important;font-weight:700!important;color:#08783f!important;text-decoration:underline!important;text-underline-offset:2px;word-break:break-word}
    `;
    root.appendChild(style);
  }

  function createPreview(url) {
    const wrapper = document.createElement('div');
    wrapper.className = PREVIEW_CLASS;
    wrapper.dataset.url = url;

    const imageLink = document.createElement('a');
    imageLink.href = url;
    imageLink.target = '_blank';
    imageLink.rel = 'noopener';
    imageLink.setAttribute('aria-label', 'Abrir diseño personalizado');

    const image = document.createElement('img');
    image.className = `${PREVIEW_CLASS}__image`;
    image.src = url;
    image.alt = 'Diseño personalizado de las espinilleras';
    image.loading = 'lazy';
    imageLink.appendChild(image);

    const copy = document.createElement('div');
    copy.className = `${PREVIEW_CLASS}__copy`;
    const label = document.createElement('span');
    label.className = `${PREVIEW_CLASS}__label`;
    label.textContent = 'Tu diseño personalizado';
    const link = document.createElement('a');
    link.className = `${PREVIEW_CLASS}__link`;
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = 'Ver diseño personalizado';
    copy.append(label, link);
    wrapper.append(imageLink, copy);
    return wrapper;
  }

  function renderPreviews(root, cart) {
    ensureStyles(root);
    const itemsByVariant = new Map();
    (cart.items || []).forEach((item) => {
      const id = String(item.variant_id || item.id || '');
      if (!itemsByVariant.has(id)) itemsByVariant.set(id, []);
      itemsByVariant.get(id).push(item);
    });

    const occurrences = new Map();
    root.querySelectorAll(ITEM_SELECTOR).forEach((card) => {
      const variantId = variantIdFromCard(card);
      const occurrence = occurrences.get(variantId) || 0;
      occurrences.set(variantId, occurrence + 1);
      const cartItem = (itemsByVariant.get(variantId) || [])[occurrence];
      const url = designUrl(cartItem);
      const existing = card.querySelector(`.${PREVIEW_CLASS}`);

      if (!url) {
        if (existing) existing.remove();
        return;
      }
      if (existing && existing.dataset.url === url) return;
      if (existing) existing.remove();

      const details = card.querySelector('.opus-product-item-details');
      const title = card.querySelector('.cd-product-item-title-container');
      (title || details || card).appendChild(createPreview(url));
    });
  }

  async function refresh() {
    if (refreshRunning) {
      refreshAgain = true;
      return;
    }
    const host = document.querySelector(HOST_SELECTOR);
    const root = host && host.shadowRoot;
    if (!root) return;

    refreshRunning = true;
    try {
      renderPreviews(root, await getCart());
    } catch (error) {
      console.warn('[Realfut] No se ha podido actualizar la vista previa de EGO.', error);
    } finally {
      refreshRunning = false;
      if (refreshAgain) {
        refreshAgain = false;
        scheduleRefresh(80);
      }
    }
  }

  function scheduleRefresh(delay = 120) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  }

  function observeEgo() {
    const root = document.querySelector(HOST_SELECTOR)?.shadowRoot;
    if (!root || root === observedRoot) return;
    if (rootObserver) rootObserver.disconnect();
    observedRoot = root;
    rootObserver = new MutationObserver((mutations) => {
      const onlyOwnChanges = mutations.every((mutation) => {
        const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
        return target && (target.closest(`.${PREVIEW_CLASS}`) || target.id === STYLE_ID);
      });
      const productListChanged = mutations.some((mutation) => {
        const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
        if (target && target.closest('.cd-product-list')) return true;
        return Array.from(mutation.addedNodes).some((node) => {
          if (!(node instanceof Element)) return false;
          return node.matches('.cd-product-list, .cd-product-item') || Boolean(node.querySelector('.cd-product-list, .cd-product-item'));
        });
      });
      if (!onlyOwnChanges && productListChanged) scheduleRefresh();
    });
    rootObserver.observe(root, { childList: true, subtree: true });
    scheduleRefresh(0);
  }

  const hostObserver = new MutationObserver(observeEgo);
  hostObserver.observe(document.documentElement, { childList: true, subtree: true });

  ['realfut:nano-added', 'cart:refresh', 'cart:updated', 'cart:item-added', 'ajaxProduct:added', 'shopify:cart:lines-update']
    .forEach((eventName) => {
      document.addEventListener(eventName, () => scheduleRefresh(100));
      window.addEventListener(eventName, () => scheduleRefresh(100));
    });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeEgo, { once: true });
  } else {
    observeEgo();
  }
})();
